import Swal from "sweetalert2";

const AlertService = {};

AlertService.success = (options) => {
  return new Promise((resolve, reject) => {
    resolve(
      Swal.fire(
        Object.assign(
          {
            confirmButtonText: "ตกลง",
            icon: "success",
            width: "40%",
          },
          options
        )
      )
    );
  });
};
AlertService.success2 = (options, lang) => {
  return new Promise((resolve, reject) => {
    resolve(
      Swal.fire(
        Object.assign(
          {
            confirmButtonText: lang === 'th' ? "ตกลง" : "OK",
            icon: "success",
            width: "40%",
          },
          options
        )
      )
    );
  });
};
AlertService.info = (options) => {
  return new Promise((resolve, reject) => {
    resolve(
      Swal.fire(
        Object.assign(
          {
            icon: "info",
            width: "40%",
          },
          options
        )
      )
    );
  });
};
AlertService.warning = (options) => {
  return new Promise((resolve, reject) => {
    resolve(
      Swal.fire(
        Object.assign(
          {
            confirmButtonText: "ตกลง",
            icon: "warning",
            width: "40%",
          },
          options
        )
      )
    );
  });
};
AlertService.warning2 = (options, lang) => {
  return new Promise((resolve, reject) => {
    resolve(
      Swal.fire(
        Object.assign(
          {
            confirmButtonText: lang === "th" ? "ตกลง" : "OK",
            icon: "warning",
            width: "40%",
          },
          options
        )
      )
    );
  });
};
AlertService.error = (options) => {
  return new Promise((resolve, reject) => {
    resolve(
      Swal.fire(
        Object.assign(
          {
            icon: "error",
            width: "40%",
          },
          options
        )
      )
    );
  });
};
AlertService.confirm = (options) => {
  return new Promise((resolve, reject) => {
    resolve(
      Swal.fire(
        Object.assign(
          {
            icon: "warning",
            showConfirmButton: true,
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ยกเลิก",
            showCancelButton: true,
            // reverseButtons: true,
            allowEscapeKey: false,
          },
          options
        )
      )
    );
  });
};
AlertService.question = (options) => {
  return new Promise((resolve, reject) => {
    resolve(
      Swal.fire(
        Object.assign(
          {
            icon: "question",
            showConfirmButton: true,
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ยกเลิก",
            showCancelButton: true,
            // reverseButtons: true,
            allowEscapeKey: false,
          },
          options
        )
      )
    );
  });
};
AlertService.question2 = (options, confirmText, cancelText) => {
  return new Promise((resolve, reject) => {
    resolve(
      Swal.fire(
        Object.assign(
          {
            icon: "question",
            showConfirmButton: true,
            confirmButtonText: confirmText,
            cancelButtonText: cancelText,
            showCancelButton: true,
            // reverseButtons: true,
            allowEscapeKey: false,
          },
          options
        )
      )
    );
  });
};
AlertService.notify = (options) => {
  return new Promise((resolve, reject) => {
    resolve(
      Swal.fire(
        Object.assign(
          {
            confirmButtonClass: "btn btn-success mr-2 ml-2",
            cancelButtonClass: "btn btn-secondary mr-2 ml-2",
            buttonsStyling: false,
            allowOutsideClick: false,
          },
          options
        )
      )
    );
  });
};
AlertService.concurrentLogin = (options) => {
  return new Promise((resolve, reject) => {
    resolve(
      Swal.fire({
        title: "มีการใช้งานผู้ใช้งานนี้อยู่ในระบบ",
        input: "radio",
        inputOptions: {
          0: "เข้าใช้งานโดยทำการนำผู้ใช้อื่นออกจากระบบ",
          1: "เข้าใช้งานตามปกติ",
          2: "ไม่เข้าใช้งาน",
        },
        inputValidator: (value) => {
          if (!value) {
            return "You need to choose something!";
          }
        },
      })
    );
  });
};
export default AlertService;
